import React from 'react'

// components
import { CFooter } from '@coreui/react-pro'

const AppFooter = () => {
  return (
    <CFooter>
      <div>
        <a href="https://www.cloudxier.com/" target="_blank" rel="noopener noreferrer">
          Cloudxier
        </a>
        <span className="ms-1">&copy; {new Date().getFullYear()}</span>
      </div>
      <div className="ms-auto">
        <span className="me-1">Powered by</span>
        <a href="https://www.cloudxier.com/" target="_blank" rel="noopener noreferrer">
          Cloudxier
        </a>
      </div>
    </CFooter>
  )
}

export default AppFooter
